import { useEffect } from "react";
import { Box } from "@mui/material";
import { useParams, useSearchParams } from "react-router";
import { EntityType } from "@common/Common.types";
import DocumentPreviewContent from "./DocumentPreviewContent";
import DocumentPreviewHeader from "./DocumentPreviewHeader";
import { PreviewableDocument } from "./DocumentPreview.types";

function DocumentPreviewPage() {
    const params = useParams<{ entityType: string; entityId: string; documentId: string }>();
    const [searchParams] = useSearchParams();

    const entityType = Number(params.entityType) as EntityType;
    const entityId = params.entityId!;
    const documentId = params.documentId!;
    const fileName = searchParams.get("fileName") ?? undefined;
    const name = searchParams.get("name") ?? fileName ?? "";
    const dataId = searchParams.get("dataId") ?? undefined;
    const documentVersionId = searchParams.get("documentVersionId") ?? undefined;
    const entityTitle = searchParams.get("entityTitle") ?? undefined;

    useEffect(() => {
        if (name) {
            document.title = name;
        }
    }, [name]);

    const previewableDocument: PreviewableDocument = {
        documentId,
        dataId,
        documentVersionId,
        fileName,
        name,
        entityTitle,
        entityType,
        entityId,
    };

    const initialDocumentId = documentVersionId ?? documentId;

    return (
        <Box sx={{ position: "fixed", inset: 0, display: "flex", flexDirection: "column", height: "100vh", width: "100vw", overflow: "hidden" }}>
            <DocumentPreviewHeader entityType={entityType} entityId={entityId} entityTitle={entityTitle} fileName={name} />
            <DocumentPreviewContent open documents={[previewableDocument]} initialDocumentId={initialDocumentId} />
        </Box>
    );
}

export default DocumentPreviewPage;
